module.exports = __webpack_public_path__ + "img/slider3.a0fcdb52.svg";